export const API_URL_BASE = `https://api.themoviedb.org/3/`;
export const API_URL_LAST = `?api_key=${process.env.REACT_APP_API_KEY}&language=en-US&page=1`;